<template lang="pug">
  
  div
    h2( class="bold" ) Most Recent 10 Batches
    div( class="text-right" )
      router-link( class="btn btn-primary btn-sm ml-2" v-bind:to="`/reporting/batches`" ) View All Batches
    div( class="wrapper wrapper-content" )
      div( class="row d-none" )
        div( class="col-lg-3" )
          MWidget( class="report-widget info" label="Links Checked" v-bind:focus="`${linksChecked}`" )
        div( class="col-lg-3" )
          MWidget( class="report-widget success" label="Passed" v-bind:focus="`${linksPassed}`" )
        div( class="col-lg-3" )
          MWidget( class="report-widget danger" label="Failed" v-bind:focus="`${linksFailed}`" )
        div( class="col-lg-3" )
          MWidget( class="report-widget" label="Last Checked" v-bind:focus="`null`" )

      div( class="ibox mt-3" )
        
        div( class="ibox-content" v-bind:class="{ 'border border-danger': viewBin }" )
          strong( v-if="viewBin" class="text-danger" ) Currently viewing deleted batches
          MRefreshQueryButton( v-bind:apollo-query="$apollo.queries.batches" )
          table( class="table table-striped" )
            thead
              tr
                th( v-if="$moonpull.currentUserHasAccessTo('geekFeatures')" ) Batch ID
                th Name / Description
                th Run By
                th Links
                th Started At
                th Audit Processing Time
                th Status
                th More

            tbody( v-if="$apollo.loading || ! batches || ! batches.items" )
              tr
                td( class="text-center" colspan="9" )
                  | Loading&nbsp;
                  i( class="fa fa-spinner fa-spin mr-2" )

            tbody( v-else-if="batches.items.length === 0" )
              tr
                td( class="text-center" colspan="9" ) There are no batches to display

            tbody( v-else )
              tr(
                v-for="batch in filteredBatches", :key="batch.id"
              )

                td( v-if="$moonpull.currentUserHasAccessTo('geekFeatures')" ) {{ batch.id }}

                td( class="batch-name" )
                  | {{ batch.name }}
                  br
                  em {{ batch.description }}

                td( class="no-break" )
                  em( v-if="batch.owner" )
                    span {{ batch.owner.email }}
                    br
                    span( v-if="batch.owner.company" ) {{ batch.owner.company.name }} &nbsp;
                    span( v-if="$moonpull.currentUserIsSuperAdmin()" )
                      span( v-if="batch.owner.company.billingId" ) | {{ batch.owner.company.billingId }}

                td
                  | {{ batch.numLinks }}
                  br
                  em ({{ batch.numLinks }})

                td( class="no-break" )
                   em {{ dateFormat(batch.startedAt, 'dd/mm/yy') }}
                   br
                   | {{ dateFormat(batch.startedAt, 'HH:MM') }}
                
                td( v-if="batch.isDone" )
                  span( v-if="! batch.finishedAt || batch.finishedAt < batch.startedAt" ) -
                  span( v-else ) {{ Math.ceil((new Date(batch.finishedAt) - new Date(batch.startedAt)) / 1000) }}s
                td( v-else ) -

                td( v-if="batch.isDone" )
                  span( class="label label-primary" ) Done
                td( v-else )
                  span( class="label" )
                    i( class="fa fa-spinner fa-spin mr-2" )
                    | &nbsp;Processing {{ batch.numCurrentCompletedAudits }} / {{ batch.numLinks }} links...

                  

                td( class="text-center" )
                  
                  div( class="btn-group" )
                    router-link(
                      class="btn btn-details btn-outline btn-info no-wrap-link"
                      v-bind:to="`/reporting/batches/${batch.id}`"
                    ) View Batch
                                        
                    button( class="btn btn-details btn-outline btn-info" v-on:click="batch.dropdownToggle = ! batch.dropdownToggle" )
                      i( class="fa fa-caret-down" )
                    
                    ul(
                      class="batch-options-dropdown dropdown-menu"
                      v-bind:class="{ 'show': batch.dropdownToggle }"
                      x-placement="bottom-start"
                    )
                      li(v-if="$moonpull.currentUserIsSuperAdmin()" )
                        MModalButton( button-classes="dropdown-item m-0" modal-size="modal-lg" v-bind:title="`Change owner for \"${batch.name}\"`" )
                          span( slot="button-inner" )
                            MMoonpullIcon( class="mr-2" )
                            | Change Owner
                          p( slot="body" class="text-left font-normal" )
                            MUserSelector( v-model="newBatchOwnerId" )
                          p( slot="footer" class="text-right font-normal" )
                            button( class="btn btn-primary" v-on:click="changeOwner(batch.id)" v-bind:disabled="innerModalLoading" )
                              MLoadingSpinner( v-if="innerModalLoading" class="mr-2" )
                              | Change Owner
                      
                      li( v-if="$moonpull.currentUserIsSuperAdmin() && batch.isDone" )
                        a(
                          class="dropdown-ite w-100 m-0"
                          href="#"
                          v-on:click.prevent="downloadCSV(batch.id)"
                          v-bind:disabled="csvIsDownloading"
                        )
                          MMoonpullIcon
                          span( v-if="csvIsDownloading" )
                            i( class="fa fa-spinner fa-spin mr-2" )
                          | &nbsp;Export

                      li
                        MModalButton( button-classes="dropdown-item m-0" modal-size="modal-lg" v-bind:title="`Rename batch \"${batch.name}\"`" )
                          span( slot="button-inner" ) Rename
                          div( slot="body" class="text-left font-normal" )
                            p
                              label( for="new-batch-name" ) New name for batch:
                              input( class="form-control" id="new-batch-name" name="new-batch-name" v-model="newBatchName" )
                            p
                              label( for="new-batch-description" ) New description for batch:
                              input( class="form-control" id="new-batch-description" name="new-batch-description" v-model="newBatchDescription" )

                          p( slot="footer" class="text-right font-normal" )
                            button( class="btn btn-primary" v-on:click="renameBatch(batch.id)" v-bind:disabled="innerModalLoading" )
                              MLoadingSpinner( v-if="innerModalLoading" class="mr-2" )
                              | Rename
                      
                      li( v-if="$moonpull.currentUserIsSuperAdmin() && ! batch.finishedAt" )
                        a( class="dropdown-item w-100 m-0" href="#" v-on:click.prevent="markBatchAsComplete(batch.id)" v-bind:disabled="updatingBatch" )
                          MLoadingSpinner( v-if="updatingBatch" )
                          | Mark as complete
                      
                      li( v-if="$moonpull.currentUserIsSuperAdmin() && ! batch.deletedAt" )
                        a( class="dropdown-item w-100 m-0" href="#" v-on:click.prevent="softDeleteBatch(batch.id)" v-bind:disabled="deletingBatch" )
                          MLoadingSpinner( v-if="deletingBatch" )
                          | Delete Batch
                      li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                        a( class="dropdown-item w-100 m-0" href="#" v-on:click.prevent="restoreBatch(batch.id)" v-bind:disabled="restoringBatch" )
                          MLoadingSpinner( v-if="restoringBatch" )
                          | Restore Batch

</template>

<style lang="scss" scoped>
.table-list {
  width: 100%;
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  td {
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  }
}
.no-break {
  word-break: normal;
}
.no-wrap-link {
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-details {
  word-break: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-title-bar {
  cursor: pointer;
}
.batch-options-dropdown {
  left: -63px;
}
</style>

<script>
import Vue from 'vue'
import * as dateFormat from 'dateformat'
import gql from 'graphql-tag'


export default Vue.extend({
  
  data() {
    return {
      linksChecked: 0,
      linksPassed: 0,
      linksFailed: 0,
      lastChecked: new Date(),
      breadcrumbs: [
        { label: 'Home', link: '/' },
        { label: 'Reporting', link: '/reporting' },
        { label: 'Your Results', link: '/reporting/batches' }
      ],
      page: 1,
      pageSize: this.$route.query.pageSize || null,
      csvIsDownloading: false,
      viewBin: false,
      deletingBatch: false,
      updatingBatch: false,
      showFilter: false,
      minLinksPerBatch: 0,
      batchFilterString: '',
      newBatchOwnerId: null,
      innerModalLoading: false,
      restoringBatch: false,
      newBatchName: '',
      newBatchDescription: '',
      linkFilterOptions: [
        { label: "All", value: "all" },
        { label: "Single", value: "single" },
        { label: "Exclude single", value: "exclude" },
        { label: "Five or more", value: "gt5" },
      ],
      selectedLinkFilter: "all",
      startDate: dateFormat(new Date(Date.now() - (10958 * 24 * 60 * 60 * 1000)), 'yyyy-mm-dd'),
      endDate: dateFormat(new Date(Date.now() + (1 * 24 * 60 * 60 * 1000)), 'yyyy-mm-dd'),
      selectedCompanyType: null,
    }
  },

  watch: {
    pageSize() {
      this.page = 1
    },
    selectedCompanyType(newVal, oldVal) {
    if (newVal) { // If a company type is selected
      this.pageSize = "100"; // Set the pageSize to 100 or any value you desire
    } else { // If company type is deselected
      this.pageSize = "10"; // Reset the pageSize to the default or any value you desire
    }
  }
  },

  apollo: {
    batches: {
      query: gql`query BatchPaginated ( $pageSize: Float!, $minNumLinks: Float!, $batchFilterString: String, $showDeleted: Boolean, $startDate: DateTime!, $endDate: DateTime!) {
        batchMany(
          perPage: $pageSize
          sort: {
            startedAt: DESC
          }
          filter: {
            isTemplate: false
            startedAt: {
              between: [ $startDate, $endDate]
            }
          }
          minNumLinks: $minNumLinks
          batchFilterString: $batchFilterString
          showDeleted: $showDeleted
        ) {
          count
          items {
            id
            owner {
              email
              company {
                name
                billingId
                companyType
              }
            }
            name
            description
            startedAt
            finishedAt
            isDone
            deletedAt
            numLinks
            numCurrentCompletedAudits
          }
        }
      }`,
      variables() {
        return {
          pageSize: Number(this.pageSize),
          showDeleted: this.viewBin,
          minNumLinks: Number(this.minLinksPerBatch),
          batchFilterString: this.batchFilterString,
          startDate: this.startDate,
          endDate: this.endDate,
          companyType: this.selectedCompanyType, // Assuming this is the variable in your Vue component
        }
      },
      update: data => {
        const batches = data.batchMany
        batches.items.forEach(b => b.dropdownToggle = false)
        return batches
      },
      debounce: 500,
    }
  },

  computed: {
    filteredBatches() {
      // Guard against undefined batches or items
      if (!this.batches || !this.batches.items) return [];

      const companyFilter = (batch) => {
        if (!this.selectedCompanyType) {
          return true;
        } else if (this.selectedCompanyType === "ALL_EXCEPT_MOONPULL") {
          return batch.owner.company.companyType !== "MOONPULL";
        } else {
          return batch.owner.company.companyType === this.selectedCompanyType;
        }
      };

      const linkFilter = (batch) => {
        const minLinks = this.minLinksPerBatch;
        const selectedFilter = this.selectedLinkFilter;

        if (selectedFilter === "all") {
          return batch.numLinks >= minLinks;
        } else if (selectedFilter === "single") {
          return batch.numCurrentCompletedAudits === 1 && batch.numLinks >= minLinks;
        } else if (selectedFilter === "exclude") {
          return batch.numCurrentCompletedAudits !== 1 && batch.numLinks >= minLinks;
        } else if (selectedFilter === "gt5") {
          return batch.numCurrentCompletedAudits >= 5 && batch.numLinks >= minLinks;
        }
        return true; // Default case
      };

      return this.batches.items.filter(batch => companyFilter(batch) && linkFilter(batch));
    },
    lastPageNum() {
      return this.batches ? Math.ceil(this.batches.count / this.pageSize) : '...'
    }
  },

  methods: {
    
    dateFormat,

    async downloadCSV(batchId) {
      this.csvIsDownloading = true
      await this.$moonpull.downloadSingleBatchCSV(batchId)
      this.csvIsDownloading = false
    },

    toggleBin() {
      this.viewBin = ! this.viewBin
      this.page = 1
    },
    handleClick(value) {
        console.log("Setting filter to:", value);
        this.selectedLinkFilter = value;
    },

    async softDeleteBatch(batchId) {
      if (confirm('Are you sure you want to delete this batch?')) {
        this.deletingBatch = true
        await this.$apollo.mutate({
          mutation: gql`mutation SoftDeleteBatch($batchId: ID!) {
            batchSoftDeleteById(
              id: $batchId
            ) { id }
          }`,
          variables: {
            batchId
          }
        })
        await this.$apollo.queries.batches.refetch()
        this.deletingBatch = false
      }
    },

    async restoreBatch(batchId) {
      this.restoringBatch = true
      await this.$apollo.mutate({
        mutation: gql`mutation RestoreBatchById($batchId: ID!) {
          batchRestoreById(id: $batchId)
        }`,
        variables: {
          batchId,
        }
      })
      this.restoringBatch = false
      this.$apollo.queries.batches.refetch()
    },

    async renameBatch(batchId) {
      if (! this.newBatchName || this.newBatchName === '') {
        this.$store.dispatch('flashMessage', { type: 'warning', msg: 'Please provide a new name for the batch' })
        return
      }
      this.innerModalLoading = true
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $record: BatchUpdateInput!) {
          batchUpdateById(
            id: $id
            record: $record
          ) {
            id
          }
        }`,
        variables: {
          id: batchId,
          record: {
            name: this.newBatchName,
            description: this.newBatchDescription,
          }
        }
      })
      this.innerModalLoading = false
      this.newBatchName = ''
      this.$emit('dismissModals')
      this.$apollo.queries.batches.refetch()
    },

    async changeOwner(batchId) {
      if (! this.newBatchOwnerId) {
        this.$store.dispatch('flashMessage', { type: 'warning', msg: 'Please select a new owner for this batch' })
        return
      }
      this.innerModalLoading = true
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $record: BatchUpdateInput!) {
          batchUpdateById(
            id: $id
            record: $record
          ) {
            id
          }
        }`,
        variables: {
          id: batchId,
          record: {
            ownerId: this.newBatchOwnerId
          }
        }
      })
      this.newBatchOwnerId = null
      this.innerModalLoading = false
      this.$emit('dismissModals')
      this.$apollo.queries.batches.refetch()
    },

    async markBatchAsComplete(batchId) {
      this.updatingBatch = true
      await this.$apollo.mutate({
        mutation: gql`
          mutation BatchUpdateFinishedAtDate($id: ID!, $record: BatchUpdateInput!) {
            batchUpdateById(
              record: $record
              id: $id
            ) { id }
          }
        `,
        variables: {
          id: batchId,
          record: {
            finishedAt: new Date(),
            status: 'FORCE_DONE',
          },
        },
      })
      this.updatingBatch = false
      this.$apollo.queries.batches.refetch()
    },

  },
  

  beforeCreate() {
    analytics.page(
      " view", {
      "path": window.location.hash,
      "referrer": window.location.hash,
    })
  },

  async mounted() {
    if ( ! this.pageSize) {
      this.pageSize = 10
    }
  }
})
</script>
